import QuickCard from './QuickCard';
export default QuickCard;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickCard/index.js